import { render, staticRenderFns } from "./BankBuilding.vue?vue&type=template&id=0e491c21&"
import script from "./BankBuilding.vue?vue&type=script&lang=js&"
export * from "./BankBuilding.vue?vue&type=script&lang=js&"
import style0 from "./BankBuilding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports